import gql from 'graphql-tag'

export const GET_INGREDIENTS_PAGINATION_QUERY = gql`
  query GetIngredientsPagination (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $query: String
  ) {
    getIngredients(
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        query: $query
      }
    ) {
      hasMore
      total
      items {
          id
          title
          unit
      }
    }
  }
`
